import * as React from 'react';
import { useState } from 'react';
import Typography from '@mui/material/Typography';
import { Container,Grid, Button } from '@mui/material';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';

const createOrder = httpsCallable(functions, 'createOrder');
const captureOrder = httpsCallable(functions, 'captureOrder');
function calcTotal(products) {
    var total = 0
    products.forEach((item) => {
      total += item.quantity * item.unit_amount.value
    })
    return total
  }

export default function PayPal({ cart, updateCart, setCartVisible }) {
    const [message, setMessage] = useState('');
    const [paid, setPaid] = useState(false)

    if (paid) {
        return (
            <Container maxWidth="sm" sx={{ marginTop: 4 }}>
                <Typography variant="h5">
                    Thank you for your purchase!
                </Typography>
            </Container>
        )
    }
    else {
        return (
            <Container maxWidth="sm" sx={{ marginTop: 4 }}>
                <Grid container spacing={1} alignItems={"center"}>
                    <Grid item xs={7}>
                    <Button variant="contained" onClick={() => {
                            updateCart([])
                            setCartVisible(true)
                        }}>Return to Cart</Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="h6">
                            Total
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="h6">
                            ${calcTotal(cart)}
                        </Typography>
                    </Grid>
                </Grid>
                <hr></hr>

                    <PayPalButtons style={{ layout: "vertical" }}
                        createOrder={async () => {
                            try {
                                const result = await createOrder({
                                    products: cart,
                                    discount: 0,
                                })
                                const orderData = result.data
                                if (orderData.id) {
                                    return orderData.id;
                                } else {
                                    const errorDetail = orderData?.details?.[0];
                                    const errorMessage = errorDetail
                                        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                        : JSON.stringify(orderData);

                                    throw new Error(errorMessage);
                                }
                            } catch (error) {
                                console.error(error);
                                setMessage(
                                    `Could not initiate PayPal Checkout...${error}`
                                );
                            }
                        }}
                        onApprove={async (dataPaypal, actions) => {
                            try {
                                console.log(dataPaypal.orderID)
                                const result = await captureOrder({
                                    orderID: dataPaypal.orderID
                                })
                                const orderData = result.data
                                console.log(orderData)
                                // Three cases to handle:
                                //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                                //   (2) Other non-recoverable errors -> Show a failure message
                                //   (3) Successful transaction -> Show confirmation or thank you message
                                const errorDetail = orderData?.details?.[0];

                                if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
                                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                                    // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                                    return actions.restart();
                                } else if (errorDetail) {
                                    // (2) Other non-recoverable errors -> Show a failure message
                                    throw new Error(
                                        `${errorDetail.description} (${orderData.debug_id})`
                                    );
                                } else {
                                    // (3) Successful transaction -> Show confirmation or thank you message
                                    // Or go to another URL:  actions.redirect('thank_you.html');

                                    /*const transaction = orderData.purchase_units[0].payments.captures[0];
                                    setMessage(
                                      `Transaction ${transaction.status}: ${transaction.id}. See console for all available details`
                                    );
                                    */
                                    setPaid(true)
                                    console.log(
                                        'Capture result',
                                        orderData,
                                        JSON.stringify(orderData, null, 2)
                                    );
                                }
                            } catch (error) {
                                console.error(error);
                                setMessage(
                                    `Sorry, your transaction could not be processed...${error}`
                                );
                            }
                        }} />
                    <Typography variant="h6" gutterBottom>
                        {message}
                    </Typography>
            </Container>
        )
    }
}